import { RouteConfig } from 'vue-router';
import MswCreateCustomer from './msw-create-customer.vue';

const createCustomerTab: RouteConfig = {
  path: 'create-customer',
  component: MswCreateCustomer,
};

export function getDefaultParams() {
  return {};
}

export default createCustomerTab;
